import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ErrorService} from '../../../../../../shared/services/error.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ContactosServiciosService} from '../contactos-servicios.service';
import {LabelComponent} from '../../../../../../shared/components/form/label/label.component';
import {GenericCombo} from '../../../../../../shared/services/interfaces/combos.interface';
import {CombosService} from '../../../../../../shared/services/combos.service';
import {forkJoin} from 'rxjs';
import {ButtonComponent} from '../../../../../../shared/components/ui/button/button.component';
import {SelectFieldComponent, SelectOption} from '@shared/components/form/select/select-field.component';
import { AppFormComponent } from '@shared/components/ui/list-components';
import { Modal } from '@shared/components/common/modal/modal';

@Component({
  selector: 'app-detalle-contacto-servicio',
  imports: [
    FormsModule,
    LabelComponent,
    ReactiveFormsModule,
    ButtonComponent,
    SelectFieldComponent,
    AppFormComponent,
    Modal,
  ],
  templateUrl: './detalle-contacto-servicio.html',
  styles: ``
})
export class DetalleContactoServicio implements OnInit {

  editForm!: FormGroup;
  loading = false;
  idContacto!: number;
  idContactoServicio!: number;
  servicios: GenericCombo[] = [];

  get serviciosOptions(): SelectOption[] { return this.servicios.map(x => ({ value: x.id, label: x.nombre })); }

  private fB = inject(FormBuilder);
  private errorService = inject(ErrorService);
  private combosService = inject(CombosService);
  private contactosServiciosService = inject(ContactosServiciosService);
  private dialogRef = inject(MatDialogRef<DetalleContactoServicio>);
  private data = inject(MAT_DIALOG_DATA);

  ngOnInit(): void {
    this.idContacto = this.data.idContacto;
    this.idContactoServicio = this.data.idContactoServicio;
    this.getCombos();
    this.makeForm();
    this.getContactoServicio();
  }

  private getCombos(): void {
    const servicios = this.combosService.getServiciosCombo();

    forkJoin([servicios]).subscribe({
      next: (response) => {
        this.servicios = response[0].data;
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    });
  }

  private makeForm(): void {
    this.editForm = this.fB.group({
      crm_contacto_id: [this.idContacto, Validators.required],
      param_servicio_id: [{ value: '', disabled: true }, Validators.required],
    });
  }

  getContactoServicio(): void {
    this.loading = true;
    this.contactosServiciosService.show(this.idContactoServicio).subscribe({
      next: (response) => {
        if (response.status) {
          this.editForm.patchValue(response.data);
        }
      }, error: (error) => {
        this.errorService.handleError(error);
      }
    }).add(() => {
      this.loading = false;
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
